import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "./Programs.css";

const Programs = (props) => {
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.removeItem("prog_edit_name");
    window.onbeforeunload = null;
  }, []);
  const handleEdit = (id) => {
    if (props.selectedTab === "Protocols") {
      localStorage.setItem("programIdEdit", id);
      navigate("/protocols/" + id);
    } else {
      localStorage.setItem("programIdEdit", id);
      navigate("/details/" + id);
    }
  };

  const wrapperRef = useRef("");
  useOutsideDotClose(wrapperRef);
  function useOutsideDotClose(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          props.closeAllModal();
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
      // eslint-disable-next-line
    }, [ref, props]);
  }




  return (
    <div className="table_component_main_container">
      <div className="programs_top_hold">
        <input
          type="text"
          ref={props.searchProgs}
          placeholder={
            "Enter " + (props.selectedTab === "Protocols" ? "Protocol" : "Recovery Plan") + " Name or problem area..."
          }
          className="programs_search_bar"
          onChange={() => props.updateSearchQuery(props.searchProgs.current.value)}
        />
        <div className="top_hold_buttons">
          <div className="programs_menu"></div>
        </div>
      </div>


      <div className="table_scrollable_container_new">
        <div className="table_scrollable_inner_container">

          {
            props?.contentLoaded ?
              <>
                {props.programsData.length > 0 ? (
                  <div className="programs_table">
                    <div className="programs_cols">
                      <div className="programs_col_info">
                        <div className="programs_col_name">{props.selectedTab === "Protocols" ? "Protocol" : "Recovery Plan"} Name</div>
                        <div
                          className="programs_col_icon"
                          onClick={() => props.handleSorting("program_name", props.programsData)}></div>
                      </div>
                      {props.selectedTab !== "Protocols" && (
                        <div className="programs_col_info">
                          <div className="programs_col_name">Patient Name</div>
                          <div
                            className="programs_col_icon"
                            onClick={() => props.handleSorting("patient_name", props.programsData)}></div>
                        </div>
                      )}
                      <div className="programs_col_info">
                        <div className="programs_col_name">Problem</div>
                        <div
                          className="programs_col_icon"
                          onClick={() => props.handleSorting("problem_name", props.programsData)}></div>
                      </div>
                      <div className="programs_col_info">
                        <div className="programs_col_name">Sub Problem</div>
                        <div
                          className="programs_col_icon"
                          onClick={() => props.handleSorting("sub_problem_name", props.programsData)}></div>
                      </div>
                      <div className="programs_col_info">
                        <div className="programs_col_name">Duration</div>
                        <div
                          className="programs_col_icon"
                          onClick={() => props.handleSorting("duration", props.programsData)}></div>
                      </div>
                      {props.selectedTab !== "Protocols" && (
                        <div className="programs_col_info">
                          <div className="programs_col_name">Assigned</div>
                          <div
                            className="programs_col_icon"
                            onClick={() => props.handleSorting("assigned", props.programsData)}></div>
                        </div>
                      )}
                      {/* {props.selectedTab !== "Protocols" && false && (
              <div className="programs_col_info">
                <div className="programs_col_name">Progress</div>
                <div
                  className="programs_col_icon"
                  onClick={() => props.handleSorting("progress", props.programsData)}></div>
              </div>
            )} */}
                    </div>
                  </div>
                ) : (
                  <div className="programs_table_no_content">
                    <div className="no_content_notice_contain">
                      <div className="programs_no_results_img"></div>
                      <div className="programs_no_res_main">
                        {props.selectedTab === "Protocols" ? "You have no protocols saved" : "You have no active programs"}
                      </div>
                      <div className="programs_no_res_elab">
                        You have 0 {props.selectedTab === "Protocols" ? "saved protocols " : "active programs"}
                      </div>

                      <Link
                        to={props.selectedTab === "Protocols" ? "/newtemplate" : "/newprogram"}
                        style={{ textDecoration: "none" }}>
                        <div className="programs_new_btn">
                          {props.selectedTab === "Protocols" ? "Create New Protocol" : "New Program"}
                        </div>
                      </Link>
                    </div>
                  </div>
                )}
                <div className="tbl_content_hold">
                  {props.programsData &&
                    props.programsData.map((item, i) => (
                      <div key={i} className="programs_tbl_content">
                        <div onClick={() => {
                          handleEdit(item.id)
                        }}>
                          <div className="programs_tbl_row">
                            <div className="programs_tbl_col_contain">
                              <div className="programs_tbl_col">{item.program_name}</div>
                            </div>
                            {props.selectedTab !== "Protocols" && (
                              <div className="programs_tbl_col_contain">
                                <div className="programs_tbl_col">{item.patient_name}</div>
                              </div>
                            )}
                            <div className="programs_tbl_col_contain">
                              <div className="programs_tbl_col">{item.problem_name}</div>
                            </div>
                            <div className="programs_tbl_col_contain">
                              <div className="programs_tbl_col">{item.sub_problem_name}</div>
                            </div>
                            <div className="programs_tbl_col_contain">
                              <div className="programs_tbl_col">
                                {Math.floor(item.duration / 7) > 0
                                  ? item.duration +
                                  (item.duration === 1 ? " day" : " days") +
                                  "/" +
                                  Math.floor(item.duration / 7) +
                                  (Math.floor(item.duration / 7) === 1 ? " week" : " weeks")
                                  : ""}
                                {Math.floor(item.duration / 7) > 0
                                  ? item.duration % 7 > 0
                                    ? " & " + (item.duration % 7) + (item.duration % 7 === 1 ? " day" : " days")
                                    : ""
                                  : item.duration + (item.duration === 1 ? " day" : " days")}
                              </div>
                            </div>
                            {props.selectedTab !== "Protocols" && (
                              <div className="programs_tbl_col_contain">
                                <div className="programs_tbl_col">{item.assigned}</div>
                              </div>
                            )}
                            {/* {props.selectedTab !== "Protocols" && false && (
                    <div className="programs_tbl_col_contain">
                      <div className="programs_tbl_col tbl_col_no_padd">
                        <div className="programs_progress_bar">
                          <div style={{ width: item.progress + "%" }} className="programs_progress_bar prog_done"></div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div
                    className="programs_tbl_col_last ep_arrow"
                    onClick={(e) => (props.selectedTab === "Protocols" ? props.openModal(i, e) : "")}>
                    {props.selectedTab === "Protocols" && item.modalOpened && (
                      <div style={{ position: "relative" }}>
                        <div
                          className={
                            i === props.programsData.length - 1
                              ? "client-list__container_last"
                              : "client-list__container"
                          }
                          ref={wrapperRef}>
                          <div
                            className="client-list-option client-list-option__delete"
                            onClick={() => props.handleDeleteTemplate(item.id)}>
                            Delete Protocol
                          </div>
                        </div>
                      </div>
                    )}
                  </div> */}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </>
              :
              <>
                <div className="programs_table_no_content">
                  <div className="no_content_notice_contain">
                    <div className="p_load"></div>
                  </div>
                </div>
              </>
          }
        </div>

      </div>
    </div>
  );
};

export default Programs;
